<template>
    <div
        class="free-period-remind"
        v-if="data && data.length"
    >
        <div
            class="free-period-remind-container"
            ref="remindContainer"
        >
            <div ref="btIcon">
                <img
                    src="//img12.360buyimg.com/jrpmobile/jfs/t1/22721/21/2838/3204/5c20bd76E4e62ba3a/447afa316a115ce9.png"
                    alt
                    class="bt-icon"
                >
            </div>

            <div
                class="free-period-remind-content"
                :style="{width:swiperWidth}"
            >
                <swiper
                    class="free-period-remind-ul"
                    :options="swiperOptions"
                >
                    <swiperSlide
                        class="slide-item"
                        v-for="(item, index) in data"
                        :key="index"
                    >
                        <div class="slide-kpl">
                            <div
                                :clstag="'jr|keycount|8530052_index_note|'+item.id"
                                class="slide-item-left-container"
                                :style="{width:width}"
                            >
                                <div class="slide-item-left">
                                    {{item.context}}
                                </div>
                            </div>
                            <div ref="slideItemRight">
                                <div class="slide-item-right">

                                </div>
                            </div>
                        </div>
                    </swiperSlide>
                </swiper>
            </div>
        </div>

    </div>
</template>
<script>
import request from '@/util/request';
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import { openByKpl } from '@/util/kpl';

import KPL from '@/buscomponents/KPL';
var obj = {};
export default {
    name: 'FreePeriodRemind',
    data() {
        return {
            width: '100%',
            swiperWidth: '100%',
            showTip: true,
            swiperOptions: {
                direction: 'vertical',
                loop: true,
                speed: 600,
                allowTouchMove: false,
                on: {
                    click: function() {
                        let me = this;
                        let realIndex = me.realIndex || 0;
                        let url = obj[realIndex].url || '';
                        let open = openByKpl;
                        if(this.$openByKpl){
                            open=this.$openByKpl;
                        }
                        open({
                            url: url
                        });
                    }
                },
                autoplay: {
                    delay: 3000,
                    disableOnInteraction: false
                }
                // autoplay: false
            },
            freePeriodRemindHeight: 0
        };
    },
    components: {
        swiper,
        swiperSlide,
        KPL
    },
    props: {
        content: {
            type: String,
            default: ''
        },
        data: {
            type: Array,
            default: () => {
                return [];
            }
        },
        swiperOption: {
            type: Object,
            default: () => {
                return {};
            }
        }
    },
    created() {
        this.update();
    },
    methods: {
        update() {},
        jumpUrl(url) {
            console.log(url);
            //Window.location.href = url;
        },
        handleClickSlide(index) {
            console.log(index);
        }
    },
    watch: {
        data: {
            handler(newValue) {
                obj = newValue;
            },
            deep: true
        }
    },
    mounted() {
        this.swiperWidth = `${$(this.$refs.remindContainer).width() - $(this.$refs.btIcon).width()}px`;
        this.width = `${$(this.$refs.remindContainer).width() - $(this.$refs.btIcon).width() - $(this.$refs.slideItemRight).width()}px`;
        setTimeout(() => {
            this.freePeriodRemindHeight = $('.free-period-remind').height();
        }, 200);
    },
    destroyed() {
        this.$refs = null;
    }
};
</script>

<style lang="scss">
@import './../scss/mixin.scss';
.free-period-remind {
    margin-top: -$rem20;
    background: #fff;
    // padding-top: $rem20;
    .free-period-remind-container {
        width: 92%;
        height: $rem64;
        background: #f8f8f8;
        border-radius: $rem32;
        margin: 0 auto;
        display: flex;
        align-items: center;
        flex-direction: row;
        //justify-content: center;
        .bt-icon {
            width: $rem120;
            height: $rem36;
            margin-left: $rem29;
            margin-right: $rem12;
            flex-shrink: 0;
        }
        .free-period-remind-content {
            flex: 1;
            .free-period-remind-ul {
                //height: $rem24;
                height: $rem64;
                overflow: hidden;
                margin: 0 auto;
                width: 100%;
                .swiper-wrapper {
                    width: 100%;
                    .slide-item {
                        width: 100%;
                        .slide-kpl {
                            width: 100%;
                            height: 100%;
                            z-index: 99;
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            flex-direction: row;
                            overflow: hidden;
                            .slide-item-left-container {
                                flex: 1;
                                .slide-item-left {
                                    font-family: PingFangSC-Regular;
                                    font-size: $rem24;
                                    color: #302f2f;
                                    letter-spacing: $rem1;
                                    text-align: justify;
                                    line-height: $rem24;
                                    width: 100%;
                                    overflow: hidden;
                                    text-overflow: ellipsis;
                                    white-space: nowrap;
                                    // display: -webkit-box;
                                    // -webkit-box-orient: vertical;
                                    // -webkit-line-clamp: 2;
                                }
                            }

                            .slide-item-right {
                                flex-shrink: 0;
                                width: $rem24;
                                height: $rem24;
                                margin-left: $rem10;
                                margin-right: $rem20;
                                background-image: url('//img12.360buyimg.com/jrpmobile/jfs/t1/21865/3/2729/288/5c20c2cdEe411a4d4/e9f1fd35cdd0d363.png');
                                background-repeat: no-repeat;
                                background-position: 0 0;
                                background-size: 100% 100%;
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>
